/**
 * SignatureNotice — the verbatim signature acknowledgment / dispute note shown
 * on every signing page, the in-app 6-Month Review panel and the copy screen.
 * The HR email is a setting (passed in from the evaluation config), never
 * hard-coded here beyond a last-resort fallback.
 */
export function SignatureNotice({ hrEmail, className = '' }) {
  const hr = hrEmail || 'hr@tricorps.com';
  return (
    <p className={`text-xs text-slate-500 leading-relaxed ${className}`} data-testid="signature-notice">
      Your signature confirms that you have reviewed and discussed this evaluation with your
      supervisor. It does not necessarily mean you agree with it. If you would like to dispute the
      evaluation or comment further, email Human Resources at{' '}
      <a href={`mailto:${hr}`} className="text-blue-600 underline hover:text-blue-700" data-testid="signature-notice-hr-link">
        {hr}
      </a>{' '}
      within 10 business days of signing.
    </p>
  );
}
